/**
  Author - Saahil Madaan
  Git - https://bitbucket.org/techSavvySaahil/
**/

"use strict";

import {addQueryParamToUrl, addValidArnQueryParam} from "./urlUtils";
import {
  applyExternalLinkAttributes,
  getExternalLinkProps,
  isInternalUrl,
  mergeExternalLinkRel,
  processExternalLinks
} from "./linkUtils";
import parseHtmlContent from "./parseHtmlContent";
import buildFaqPageSchema from "./buildFaqPageSchema";
import {
  useCheckIsPartnerApp,
  useCheckMobileView,
  useCurrentPageUrl,
  useDebounce,
  useImpetusDesktopMeeting,
  useInfiniteScroll,
  useOnClickOutside,
  usePopUpVisibility,
  useScript
} from "./hooks";

import ContentTypes from "./types";
import {
  OnboardingContext
} from "./context";
import WealthyEncrypt from "./WealthyEncrypt";
import WealthyEnv from "./env";
import WealthyValidations from "./validations";
import capitalizeAfterSpace from "./capitalizeAfterSpace";
import getInitialsOfName from "./getInitialsOfName";
import getAuthToken from "./getAuthToken";
import getClickIds from "./getClickIds";
import getRSessionId from "./getRSessionId";
import getUtmTags from "./getUtmTags";
import handleApiError from "./utils";
import handleAuthError from "./handleAuthError";
import handleFuryApiError from "./handleFuryApiError";
import handleNewApiError from "./handleNewApiError";
import openScheduler from "./calendly";
import replaceWith from "./replaceWith";
import triggerToast from "./notifications";
import use12hrTimeFormat from "./use12hrTimeFormat";
import useMonthLettersDateFormat from "./useMonthLettersDateFormat";
import useUTCtoLocalTime from "./useUTCtoLocalTime";
import validateLeadFormData from "./validateLeadFormData";

export {
  WealthyEnv,
  WealthyValidations,
  triggerToast,
  openScheduler,
  handleApiError,
  handleNewApiError,
  getUtmTags,
  getClickIds,
  getRSessionId,
  getAuthToken,
  ContentTypes,
  validateLeadFormData,

  usePopUpVisibility,
  useOnClickOutside,
  useDebounce,
  useScript,
  useCheckMobileView,
  useImpetusDesktopMeeting,
  useCheckIsPartnerApp,
  useCurrentPageUrl,
  useInfiniteScroll,
  getInitialsOfName,
  WealthyEncrypt,

  OnboardingContext,
  capitalizeAfterSpace,
  replaceWith,
  handleFuryApiError,
  useUTCtoLocalTime,
  use12hrTimeFormat,
  useMonthLettersDateFormat,
  handleAuthError,
  addValidArnQueryParam,
  addQueryParamToUrl,
  isInternalUrl,
  mergeExternalLinkRel,
  applyExternalLinkAttributes,
  getExternalLinkProps,
  processExternalLinks,
  parseHtmlContent,
  buildFaqPageSchema
};
